webpackJsonp([0],{

/***/ "+7x5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mainContainer"}},[_c('h1',[_vm._v("DOWNLOAD")]),_vm._v(" "),_vm._m(0),_c('div',{staticClass:"noSelect",attrs:{"id":"downloadBtns"}},[_c('span',{attrs:{"id":"licenseLogo"}},[_c('a',{attrs:{"href":"https://github.com/JUL1/CommandoThug/archive/master.zip","download":""}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"720","height":"358","version":"1.1"}},[_c('g',{attrs:{"id":"g1","transform":"translate(-26.149211,-6.9701601)"}},[_c('path',{attrs:{"id":"path1","d":"m 107.04146,18.25331 c 2e-5,0 -59.309734,258.76742 -59.309734,258.76742 0.01705,0 0.01919,0 0.05329,0 0,0 274.380814,0 274.380814,0 10e-6,0 142.70573,0 142.70573,0 -17.00107,-1.48353 -30.42327,-7.45182 -38.42076,-18.33112 -1.48353,-2.01219 -2.70918,-4.17993 -3.78347,-6.44788 -0.68207,-1.6711 -1.32368,-3.35715 -1.97167,-5.06237 -1.70524,-5.42261 -2.38517,-11.43991 -2.07824,-17.85154 0.85262,-17.87074 9.23805,-39.12802 23.76654,-61.38798 15.43225,-23.65656 37.79837,-48.45089 65.49116,-71.45944 6.20699,-5.15319 12.62503,-10.24199 19.34361,-15.18714 8.30441,-6.10979 16.67281,-11.73661 25.04545,-16.99893 30.84745,-19.42077 61.61817,-33.01012 88.88467,-39.91282 -26.05577,8.50051 -55.32805,22.93138 -84.24861,42.57724 -1.04016,0.70255 -2.06758,1.42215 -3.09072,2.13152 -16.04613,11.11805 -30.58314,22.92586 -43.26998,34.85046 -40.82303,38.38457 -62.40046,78.15884 -52.59544,101.46069 0.69916,1.6029 1.53256,3.13335 2.50455,4.58279 10.53825,15.50047 36.65587,18.17979 69.75422,9.85831 2.25089,-0.56275 4.50178,-1.20004 6.82088,-1.86508 10.57238,-3.05237 21.797,-7.17473 33.3584,-12.25628 2.77949,-1.22777 5.58887,-2.48963 8.41953,-3.83676 0.28988,-0.13641 0.56273,-0.27283 0.85261,-0.4263 36.49173,-18.13162 64.53625,-38.99458 70.60684,-51.52967 1.33008,-2.72662 1.6498,-5.0513 0.74603,-6.87417 -4.33124,-8.78188 -34.63945,-2.849 -71.35287,13.0556 -2.95003,1.2789 -5.93417,2.59492 -8.95241,3.99661 2.45552,-2.27986 5.01123,-4.56828 7.6202,-6.82089 4.16075,-3.58438 8.46856,-7.08945 13.0556,-10.55104 7.179,-5.43627 14.43685,-10.35071 21.58173,-14.70754 33.45643,-25.24067 50.3701,-49.11722 46.8403,-57.97753 -0.66505,-1.66943 -2.08037,-2.81789 -4.26306,-3.51703 -6.97438,-2.21847 -19.70383,0.42929 -35.17019,6.7676 -12.75504,5.23164 -27.40504,12.9908 -42.25752,22.64748 0,0 -2.02495,1.3322 -2.02495,1.3322 2e-5,0 -0.37302,0.21314 -0.37302,0.21314 2e-5,2e-5 -7.14061,4.74265 -7.14061,4.74265 -2e-5,-1e-5 4.10319,-7.51363 4.10319,-7.51363 6.08765,-11.14364 16.0035,-22.77067 28.3493,-33.57154 9.05473,-7.89689 19.39903,-15.33762 30.53413,-21.84816 4.21191,-2.46573 8.4174,-4.75586 12.62929,-6.82088 4.31422,-2.10769 8.63055,-3.98089 12.84246,-5.64859 12.23682,-4.8393 23.91781,-7.7798 34.10442,-8.5794 -0.92767,0 -28.61574,0 -28.61574,0 10e-6,0 -96.45159,0 -96.45159,0 10e-6,0 -425.29295,0 -425.29295,0 0,0 -33.73141,0 -33.73141,0 z m 305.98071,0.3731 c -1.67109,25.50496 3.27403,62.86211 14.49439,104.3382 1.99509,7.38021 4.16712,14.89085 6.55444,22.48762 1.48356,4.69104 3.01399,9.30881 4.58278,13.85492 -0.9208,1.35396 -1.84804,2.69937 -2.7177,4.0499 -13.99985,21.45508 -22.1828,41.73104 -24.24611,59.36303 -5.91714,-19.81468 -10.37201,-41.5183 -12.89574,-64.53198 -0.71619,-6.5941 -1.27679,-13.11442 -1.65194,-19.55675 -2.76247,-46.79639 3.34649,-89.2172 15.87988,-120.00494 z m -279.3899,33.1985 c 0.31934,-0.0075 0.63414,0 0.95918,0 0,-2e-5 63.03991,0 63.03991,0 5.38851,-2e-5 9.55564,1.00991 12.52272,3.03742 2.95002,2.03946 4.05631,4.67743 3.35715,7.88665 2e-5,2e-5 -7.51363,33.94456 -7.51363,33.94456 0,3e-5 -22.22116,0 -22.22116,0 2e-5,3e-5 7.30048,-33.03866 7.30048,-33.03866 -2e-5,0 -55.63285,0 -55.63285,0 -2e-5,0 -20.08965,90.80305 -20.08965,90.80305 2e-5,0 -7.24719,32.87881 -7.24719,32.87881 0,3e-5 55.57957,0 55.57957,0 0,3e-5 0.0533,-0.21316 0.0533,-0.21316 0,2e-5 11.13722,-50.30404 11.13722,-50.30404 0,-2e-5 -26.1112,0 -26.1112,0 0,-2e-5 2.50454,-11.35038 2.50454,-11.35038 -1e-5,-2e-5 48.33238,0 48.33238,0 0,-2e-5 -13.85493,62.77348 -13.85493,62.77348 -0.18757,0.89352 -0.51582,1.70308 -0.95919,2.50453 -1.14249,2.08037 -3.13547,3.86234 -5.91498,5.32883 -3.85378,2.02923 -8.46643,3.03742 -13.85493,3.03742 0,2e-5 -62.98662,0 -62.98662,0 -5.388524,2e-5 -9.555644,-1.00821 -12.522724,-3.03742 -2.95001,-2.0292 -4.07335,-4.62073 -3.35715,-7.83336 10e-6,-2e-5 27.763134,-125.49366 27.763134,-125.49366 0.71618,-3.20921 2.95005,-5.84721 6.82089,-7.88665 0.13642,-0.07331 0.28989,-0.08995 0.4263,-0.15986 3.53302,-1.7697 7.67937,-2.76443 12.46944,-2.87756 z m 98.79628,0 c -2e-5,-2e-5 79.34608,0 79.34608,0 5.32031,-2e-5 9.50235,1.00991 12.46943,3.03742 2.98417,2.03946 4.12666,4.67743 3.41045,7.88665 2e-5,2e-5 -14.81411,66.92995 -14.81411,66.92995 -0.69912,3.18874 -2.98627,5.7905 -6.87417,7.83336 -3.8879,2.04966 -8.4643,3.09071 -13.80164,3.09071 -2e-5,0 -57.6578,0 -57.6578,0 0,0 -11.13723,50.25075 -11.13723,50.25075 0,2e-5 -1.8118,8.25967 -1.8118,8.25967 1e-5,2e-5 -21.74158,0 -21.74158,0 0,2e-5 1.65193,-7.46034 1.65193,-7.46034 0,2e-5 30.96044,-139.82817 30.96044,-139.82817 z m 109.61377,0 c -1e-5,-2e-5 21.74158,0 21.74158,0 2e-5,-2e-5 -24.61914,111.21241 -24.61914,111.21241 2e-5,2e-5 -5.3821,24.29942 -5.3821,24.29942 0,3e-5 52.00926,0 52.00926,0 0.54568,3.98854 1.18299,7.90582 1.86508,11.77668 -2e-5,2e-5 -78.22705,0 -78.22705,0 2e-5,2e-5 6.18143,-27.92301 6.18143,-27.92301 2e-5,0 26.43094,-119.3655 26.43094,-119.3655 z M 251.559,63.65488 c 2e-5,0 -14.4411,65.11814 -14.4411,65.11814 0,-2e-5 54.19408,0 54.19408,0 -1e-5,-2e-5 14.3878,-65.11814 14.3878,-65.11814 2e-5,0 -54.14078,0 -54.14078,0 z m -45.5614,145.68987 c 0.21267,-0.007 0.42524,0 0.63947,0 2.52373,2e-5 4.72772,0.44336 6.50115,1.27891 1.8928,0.88671 3.24632,2.204 3.99662,3.94333 0.73325,1.68819 0.92508,3.60441 0.53287,5.70184 0,1e-5 -0.15985,0.79933 -0.15985,0.79933 1e-5,-3e-5 -6.23472,0 -6.23472,0 -2e-5,-3e-5 0.0533,-0.74605 0.0533,-0.74605 0.16118,-1.46543 -0.0205,-2.61779 -0.58618,-3.41043 -0.0737,-0.0994 -0.18053,-0.23063 -0.26644,-0.31973 -0.14068,-0.14363 -0.35198,-0.3078 -0.53287,-0.42631 -0.87238,-0.5495 -2.23703,-0.85262 -3.99662,-0.85262 -2.33615,2e-5 -4.08187,0.40712 -5.27552,1.22564 -1.15956,0.80146 -1.8928,1.6967 -2.13153,2.77098 -0.23875,1.09134 0.15346,1.66472 0.42631,1.97166 0.008,0.008 0.0429,0.0438 0.0533,0.0533 0.34552,0.29445 1.54536,0.98476 5.27553,1.86508 3.37632,0.81851 5.61232,1.55389 6.87418,2.18482 1.90987,0.97196 3.24419,2.2317 3.94334,3.78346 0.69911,1.53472 0.8526,3.33157 0.4263,5.27553 -0.4263,1.89279 -1.39189,3.63852 -2.82428,5.27554 -1.41532,1.637 -3.21647,2.93297 -5.38211,3.83673 -2.1486,0.88672 -4.50604,1.38549 -6.92746,1.38549 -3.0694,-1e-5 -5.53343,-0.46467 -7.46034,-1.38549 -2.01217,-0.95491 -3.46374,-2.4619 -4.31634,-4.42291 -0.81851,-1.90986 -0.9933,-4.07762 -0.53289,-6.44786 0,-3e-5 0.15987,-0.74605 0.15987,-0.74605 0,0 6.12814,0 6.12814,0 0,0 -0.0533,0.74605 -0.0533,0.74605 -0.15348,1.41532 -0.002,2.55782 0.37302,3.41043 0.35809,0.81853 1.04019,1.49633 2.13152,2.02496 1.15954,0.5627 2.60898,0.8526 4.26305,0.8526 1.48355,-1e-5 2.83921,-0.24939 4.04991,-0.69273 1.19365,-0.4263 2.14218,-0.98904 2.82427,-1.70523 0.66502,-0.71622 1.05511,-1.47288 1.22563,-2.2914 0.17052,-0.73324 0.13002,-1.3535 -0.15987,-1.86508 -0.32399,-0.54564 -0.96558,-1.02953 -1.97165,-1.43878 0,-1e-5 -5.22226,-1.54536 -5.22226,-1.54536 -2.91592,-0.73323 -4.87905,-1.43238 -6.02155,-2.13152 -1.55177,-0.92081 -2.67081,-2.10169 -3.25059,-3.51702 -0.57977,-1.39831 -0.64158,-2.94791 -0.26643,-4.63608 0.3922,-1.80753 1.26399,-3.52767 2.61111,-5.06237 1.3642,-1.55177 3.12482,-2.76885 5.22225,-3.57031 1.85443,-0.6954 3.80596,-1.10321 5.86169,-1.17234 z m 55.9526,0.10658 c 0.33725,-0.0263 0.65436,0 1.01247,0 10e-6,0 3.83675,0.4263 3.83675,0.4263 -10e-6,0 1.27891,0.10658 1.27891,0.10658 2e-5,1e-5 -1.86508,4.74264 -1.86508,4.74264 -1e-5,2e-5 -0.37302,0.74604 -0.37302,0.74604 0,-2e-5 -2.93084,-0.26644 -2.93084,-0.26644 -0.86541,0 -1.50113,0.13352 -1.91838,0.4263 -0.0277,0.0209 -0.081,0.0842 -0.10658,0.10658 -0.0559,0.049 -0.14991,0.13458 -0.21315,0.21316 -0.25659,0.33651 -0.56912,0.93786 -0.79932,2.02495 -2e-5,0 -0.11084,0.4604 -0.21315,0.85261 1.34713,1e-5 4.58277,0 4.58277,0 0,1e-5 -1.17233,5.27552 -1.17233,5.27552 0,-1e-5 -3.35076,0 -4.4762,0 -0.34106,1.53469 -4.5295,20.3028 -4.5295,20.3028 -2e-5,-2e-5 -6.18143,0 -6.18143,0 -2e-5,-2e-5 4.01793,-18.03485 4.5295,-20.3028 -1.04021,-1e-5 -3.57031,0 -3.57031,0 0,-1e-5 1.17234,-5.27552 1.17234,-5.27552 10e-6,1e-5 2.54504,0 3.51701,0 0.17052,-0.73324 0.4263,-1.65194 0.4263,-1.65194 0.37516,-1.70522 0.76735,-2.93085 1.27891,-3.78346 0.69917,-1.17659 1.68606,-2.16137 2.93087,-2.87756 1.02527,-0.59575 2.32198,-0.95194 3.78346,-1.06576 z m 14.76082,0.26644 c -2e-5,-1e-5 -1.6157,7.27064 -2.02495,9.11228 1.19364,1e-5 3.99661,0 3.99661,0 0,1e-5 -1.17233,5.27552 -1.17233,5.27552 -2e-5,-1e-5 -2.93939,0 -3.99662,0 -0.32401,1.46647 -2.87756,12.84246 -2.87756,12.84246 2e-5,-2e-5 -0.21316,1.36631 -0.21316,1.75851 2.8e-4,0.0131 -10e-4,0.0437 0,0.0533 8.4e-4,0.004 -10e-4,0.05 0,0.0533 0.002,0.003 0.0512,-0.002 0.0533,0 0,-2e-5 0.63947,0.0533 0.63947,0.0533 0,0 2.93085,-0.21315 2.93085,-0.21315 0,0 -0.31973,4.74264 -0.31973,4.74264 2e-5,0 0.0533,0.85261 0.0533,0.85261 -2e-5,-2e-5 -4.20978,0.4796 -4.20978,0.4796 -1.6711,-2e-5 -2.89675,-0.27283 -3.78346,-0.8526 -0.93785,-0.61392 -1.48354,-1.42814 -1.70522,-2.45126 -0.0341,-0.18759 -0.10658,-0.46042 -0.10658,-0.85261 0,-0.76736 0.14495,-2.06545 0.63946,-4.31634 2e-5,2e-5 2.24023,-10.03524 2.7177,-12.14972 -0.80143,-1e-5 -2.93085,0 -2.93085,0 2e-5,-1e-5 1.17233,-5.27552 1.17233,-5.27552 -2e-5,10e-6 2.07824,0 2.93086,0 0.27281,-1.22775 1.22562,-5.4354 1.22562,-5.4354 0,2e-5 4.95581,-2.61112 4.95581,-2.61112 -10e-6,2e-5 2.02495,-1.06576 2.02495,-1.06576 z m -196.366934,0.21315 c 2e-5,0 23.979684,0 23.979684,0 0,0 -1.3322,5.96828 -1.3322,5.96828 0,2e-5 -15.997114,0 -17.531814,0 -0.27282,1.21073 -1.36631,6.11322 -1.75851,7.88665 2.2168,0 15.18713,0 15.18713,0 0,0 -1.33221,5.96826 -1.33221,5.96826 -1e-5,0 -13.65242,0 -15.18713,0 -0.32399,1.48355 -3.25058,14.65426 -3.25058,14.65426 2e-5,-2e-5 -6.44786,0 -6.44786,0 1e-5,-2e-5 7.67349,-34.47745 7.67349,-34.47745 z m 32.132764,8.41954 c 0.24067,-0.0296 0.50358,0 0.74604,0 1.5347,0 2.95217,0.4668 4.31635,1.43877 0,2e-5 0.8526,0.58617 0.8526,0.58617 0,0 -3.30386,5.4354 -3.30386,5.4354 0,-2e-5 -0.90589,-0.63946 -0.90589,-0.63946 -0.66504,-0.42629 -1.38123,-0.63946 -2.13153,-0.63946 -0.64799,2e-5 -1.25121,0.2302 -1.86509,0.63946 -0.64797,0.4263 -1.1894,0.99115 -1.59864,1.75851 -0.7162,1.31304 -1.24056,2.78377 -1.59865,4.36963 0,1e-5 -2.87756,13.10889 -2.87756,13.10889 0,-2e-5 -6.181434,0 -6.181434,0 0,-2e-5 5.701844,-25.57832 5.701844,-25.57832 2e-5,1e-5 5.75512,0 5.75512,0 0,1e-5 -0.19824,0.77588 -0.26645,1.06576 0.27284,-0.20461 0.56059,-0.48599 0.79933,-0.63946 0.82597,-0.4929 1.69837,-0.80035 2.55782,-0.90589 z m 18.33114,0 c 0.37219,-0.0282 0.73859,0 1.11906,0 3.47866,0 6.11108,1.21922 7.83335,3.62359 1.07428,1.55174 1.65195,3.47012 1.65195,5.75512 0,1.26185 -0.15561,2.61965 -0.47959,4.10319 0,0 -0.47961,1.86509 -0.47961,1.86509 0,-2e-5 -15.63261,0 -17.37194,0 -0.0341,0.35808 -0.0533,0.74177 -0.0533,1.06576 0,1.33009 0.27283,2.37665 0.85261,3.14401 0.2755,0.37513 0.5949,0.71299 0.95919,0.95918 0.68678,0.44789 1.57334,0.69275 2.61112,0.69275 1.26188,-2e-5 2.37025,-0.34745 3.41044,-1.01248 0.98905,-0.63093 1.93544,-1.63914 2.77099,-3.03742 0,-3e-5 6.60773,0 6.60773,0 0,-3e-5 -0.58616,1.27891 -0.58616,1.27891 -1.26187,2.55785 -3.02251,4.55294 -5.22225,5.96828 -2.19973,1.41533 -4.82791,2.1848 -7.72679,2.1848 -3.76854,-1e-5 -6.57363,-1.21922 -8.31296,-3.62358 -1.72226,-2.35323 -2.09315,-5.60593 -1.17233,-9.69846 0.92083,-4.16073 2.7582,-7.48591 5.43539,-9.80502 2.39958,-2.08062 5.12245,-3.23468 8.15309,-3.46372 z m 27.76315,0 c 0.37218,-0.0282 0.73857,0 1.11904,0 3.47867,0 6.1111,1.21922 7.83337,3.62359 1.07429,1.55174 1.65193,3.47012 1.65193,5.75512 0,1.2448 -0.1556,2.58341 -0.4796,4.0499 0,2e-5 -0.47958,1.91838 -0.47958,1.91838 0,-2e-5 -15.63263,0 -17.37195,0 -0.0171,0.2387 -0.0362,0.45402 -0.0533,0.69275 -0.0128,0.0895 0.006,0.22541 0,0.31972 -5e-4,0.0154 0,0.0384 0,0.0533 0,0.2558 0.0362,0.5073 0.0533,0.74604 0.0852,0.97196 0.33892,1.78409 0.79932,2.39797 0.0877,0.11936 0.17008,0.2667 0.26644,0.37302 0.78101,0.83554 1.8864,1.27891 3.30387,1.27891 1.26188,-2e-5 2.38731,-0.34745 3.41045,-1.01248 0.98904,-0.63093 1.93542,-1.63914 2.77098,-3.03742 0,-3e-5 6.66102,0 6.66102,0 -1e-5,-3e-5 -0.63946,1.27891 -0.63946,1.27891 -1.26186,2.55785 -3.0225,4.55294 -5.22224,5.96828 -2.19974,1.41533 -4.82791,2.1848 -7.72678,2.1848 -3.76853,-1e-5 -6.57363,-1.21922 -8.31296,-3.62358 -1.12545,-1.53472 -1.65194,-3.48931 -1.65194,-5.80841 0,-0.35812 0.0192,-0.74391 0.0533,-1.11905 0.0682,-0.88671 0.20463,-1.78196 0.42631,-2.771 0.92084,-4.14368 2.70491,-7.48591 5.3821,-9.80502 2.39957,-2.08062 5.17575,-3.23468 8.20639,-3.46372 z m 75.61591,0 c 0.38084,-0.0293 0.73112,0 1.11905,0 3.54687,0 6.2731,1.20004 8.04652,3.5703 1.7564,2.37023 2.18269,5.56754 1.27891,9.59186 -0.69913,3.13763 -1.70947,5.672 -3.0907,7.51365 -1.38126,1.84165 -3.14188,3.34649 -5.22226,4.36962 -2.06328,1.02314 -4.24813,1.54535 -6.44786,1.54535 -3.61507,-1e-5 -6.30719,-1.23628 -8.04652,-3.62358 -1.12546,-1.51764 -1.70522,-3.47226 -1.70522,-5.80841 2e-5,-1.26187 0.13856,-2.6026 0.4796,-4.10319 1.02315,-4.57001 3.11202,-8.05078 6.18143,-10.28462 2.25301,-1.62634 4.74114,-2.56606 7.40705,-2.77098 z m 93.62733,0 c 0.4496,-0.0277 0.86593,0 1.3322,0 2.14859,0 3.83675,0.2174 5.11567,0.74602 1.36418,0.54569 2.33189,1.31729 2.87756,2.23811 0.52864,0.86963 0.79933,1.93756 0.79933,3.25057 10e-6,2e-5 -0.63948,3.89004 -0.63948,3.89004 3e-5,0 -1.17232,5.27554 -1.17232,5.27554 -1.00611,4.50176 -1.22776,6.18995 -1.27893,6.82089 -0.0512,0.85262 0.0277,1.6839 0.26645,2.45125 2e-5,-2e-5 0.4263,1.38549 0.4263,1.38549 2e-5,-2e-5 -6.288,0 -6.288,0 -2e-5,-2e-5 -0.26645,-0.79933 -0.26645,-0.79933 -0.10231,-0.37512 -0.0725,-0.8526 -0.10657,-1.27891 -1.19365,0.73325 -2.38944,1.38336 -3.46373,1.75851 -1.58584,0.54569 -3.23139,0.8526 -4.90251,0.8526 -2.89886,-1e-5 -5.04532,-0.75454 -6.3413,-2.2381 -0.98902,-1.09133 -1.43877,-2.42567 -1.43877,-3.94332 -2e-5,-0.57977 0.0767,-1.18087 0.21314,-1.81179 0.28988,-1.29597 0.81638,-2.49603 1.65194,-3.57032 0.81851,-1.05726 1.78623,-1.92689 2.87756,-2.55782 1.05726,-0.63092 2.23598,-1.07855 3.46374,-1.3855 -2e-5,0 3.78346,-0.63946 3.78346,-0.63946 2.91594,-0.34106 5.09221,-0.76521 6.66102,-1.22562 0.0341,-0.17052 0.10657,-0.37302 0.10657,-0.37302 0.24726,-1.09718 0.21632,-1.92188 -0.0533,-2.34468 -0.0198,-0.0273 -0.0842,-0.0831 -0.10657,-0.10658 -0.0576,-0.0614 -0.14603,-0.15779 -0.21316,-0.21315 -0.64135,-0.50753 -1.73506,-0.74603 -3.19728,-0.74603 -1.65407,0 -2.87756,0.27071 -3.73018,0.79931 -0.83555,0.52863 -1.60931,1.49634 -2.29139,2.87756 -1e-5,-1e-5 -6.44787,0 -6.44787,0 2e-5,-1e-5 0.58617,-1.27891 0.58617,-1.27891 0.76733,-1.77345 1.68178,-3.24418 2.82428,-4.36963 1.1425,-1.12547 2.68572,-1.99724 4.4762,-2.61111 1.37216,-0.45297 2.8705,-0.75354 4.47621,-0.85261 z m 27.01711,0 c 0.24046,-0.0296 0.50356,0 0.74603,0 1.55173,0 3.00545,0.4668 4.36963,1.43877 2e-5,2e-5 0.79932,0.58617 0.79932,0.58617 1e-5,0 -3.30386,5.4354 -3.30386,5.4354 10e-6,-2e-5 -0.9059,-0.63946 -0.9059,-0.63946 -0.66503,-0.42629 -1.34501,-0.63946 -2.07824,-0.63946 -0.64801,2e-5 -1.28744,0.2302 -1.91839,0.63946 -0.64797,0.4263 -1.11904,0.99115 -1.54534,1.75851 -0.69916,1.31304 -1.24056,2.78377 -1.59865,4.36963 -2e-5,1e-5 -2.93085,13.10889 -2.93085,13.10889 2e-5,-2e-5 -6.18142,0 -6.18142,0 0,-2e-5 5.70182,-25.57832 5.70182,-25.57832 -10e-6,1e-5 5.75512,0 5.75512,0 0,1e-5 -0.14494,0.77588 -0.21314,1.06576 0.27282,-0.20461 0.54353,-0.48599 0.79932,-0.63946 0.81263,-0.4929 1.64571,-0.80035 2.50455,-0.90589 z m 18.27783,0 c 0.37185,-0.0282 0.73859,0 1.11906,0 3.47866,0 6.12813,1.21922 7.83337,3.62359 1.09135,1.55174 1.65193,3.47012 1.65193,5.75512 -2e-5,1.26185 -0.2089,2.61965 -0.53289,4.10319 0,0 -0.4263,1.86509 -0.4263,1.86509 -10e-6,-2e-5 -15.64968,0 -17.37194,0 -0.0341,0.35808 -0.10659,0.74177 -0.10659,1.06576 0,1.33009 0.28989,2.37665 0.85262,3.14401 0.0877,0.11936 0.223,0.2667 0.31972,0.37302 0.056,0.0597 0.15412,0.15773 0.21316,0.21314 0.76235,0.69302 1.79981,1.06577 3.0907,1.06577 1.26189,-2e-5 2.37027,-0.34745 3.41045,-1.01248 0.98905,-0.63093 1.91839,-1.63914 2.77099,-3.03742 -2e-5,-3e-5 6.66102,0 6.66102,0 0,-3e-5 -0.63946,1.27891 -0.63946,1.27891 -1.26187,2.55785 -3.03955,4.55294 -5.22224,5.96828 -2.21677,1.41533 -4.81085,2.1848 -7.72679,2.1848 -3.76851,-1e-5 -6.52034,-1.21922 -8.25966,-3.62358 -1.7223,-2.35323 -2.1294,-5.60593 -1.22563,-9.69846 0.92081,-4.16073 2.70491,-7.48591 5.38211,-9.80502 2.41475,-2.08062 5.17852,-3.23468 8.20637,-3.46372 z m -93.3076,0.47959 c 2e-5,1e-5 6.34131,0 6.34131,0 2e-5,1e-5 0.78226,15.17861 0.79931,15.40027 0.25578,-0.54356 0.45424,-1.00087 0.47961,-1.06575 1e-5,1e-5 6.98074,-14.33452 6.98074,-14.33452 2e-5,1e-5 5.80841,0 5.80841,0 -10e-6,1e-5 0.53288,14.99528 0.53288,15.08054 0.17055,-0.30691 7.93994,-15.08054 7.93994,-15.08054 -2e-5,1e-5 6.28801,0 6.28801,0 -10e-6,1e-5 -13.85493,25.57832 -13.85493,25.57832 2e-5,-2e-5 -5.70183,0 -5.70183,0 0,-2e-5 -0.55206,-13.86984 -0.58617,-14.65426 -2.35323,4.8258 -7.14063,14.65426 -7.14063,14.65426 0,-2e-5 -5.86168,0 -5.86168,0 0,-2e-5 -2.02497,-25.57832 -2.02497,-25.57832 z m -148.88715,4.84922 c -1.46893,0.062 -2.80295,0.59149 -4.04989,1.59864 -0.98902,0.78441 -1.65621,1.86084 -2.18483,3.03743 0,2e-5 10.49777,0 10.49777,0 0.0171,-0.18756 0.0533,-0.41564 0.0533,-0.58617 -2e-5,-0.97195 -0.17266,-1.72653 -0.47959,-2.2381 -0.75028,-1.22777 -1.86295,-1.8118 -3.51702,-1.8118 -0.0991,0 -0.2218,-0.004 -0.31973,0 z m 27.76313,0 c -1.46892,0.062 -2.80295,0.59149 -4.0499,1.59864 -0.98904,0.78441 -1.63913,1.86084 -2.1848,3.03743 0,2e-5 10.49776,0 10.49776,0 0.017,-0.18756 0.0533,-0.41564 0.0533,-0.58617 -1e-5,-0.97195 -0.1556,-1.72653 -0.4796,-2.2381 -0.14894,-0.24939 -0.35043,-0.49739 -0.53288,-0.69274 -0.71199,-0.73572 -1.6919,-1.11906 -2.98413,-1.11906 -0.0991,0 -0.2218,-0.004 -0.31974,0 z m 214.75136,0 c -1.51056,0.0465 -2.92125,0.55794 -4.20977,1.59864 -0.97198,0.78441 -1.63915,1.86084 -2.18482,3.03743 2e-5,2e-5 10.44449,0 10.44449,0 0.017,-0.18756 0.0533,-0.41564 0.0533,-0.58617 -1e-5,-0.97195 -0.1556,-1.72653 -0.4796,-2.2381 -0.73324,-1.21072 -1.86296,-1.79474 -3.51702,-1.8118 -0.049,5.3e-4 -0.0578,-0.001 -0.10657,0 z m -139.61502,0.10658 c -1.40963,0.16739 -2.72036,0.81051 -3.94333,1.91837 -1.46648,1.33009 -2.53012,3.41897 -3.14399,6.18143 -0.25579,1.15955 -0.37303,2.15071 -0.37303,3.03742 2e-5,1.2107 0.23233,2.16137 0.69275,2.87756 0.12257,0.18384 0.28516,0.37811 0.42631,0.53289 0.75804,0.80488 1.81659,1.22563 3.144,1.22563 1.72226,-2e-5 3.23992,-0.64159 4.68935,-1.97167 1.46652,-1.34714 2.51307,-3.45734 3.144,-6.288 0.5798,-2.59195 0.49878,-4.52736 -0.31972,-5.75512 -0.7844,-1.19366 -1.93116,-1.75851 -3.51701,-1.75851 -0.26911,0 -0.5383,-0.031 -0.79933,0 z m 96.29173,9.32543 c -1.44941,0.39218 -3.07367,0.72258 -5.22224,1.01248 -1.60289,0.23874 -2.74541,0.49024 -3.41045,0.74603 -0.57976,0.23872 -1.04658,0.56911 -1.43878,1.01248 -0.37516,0.42627 -0.62666,0.87392 -0.74602,1.38549 -0.0341,0.20464 -0.0533,0.41564 -0.0533,0.58617 0,0.0138 -3.1e-4,0.0396 0,0.0533 0.002,0.0406 -0.004,0.1207 0,0.15985 0.0107,0.0774 0.0322,0.1944 0.0533,0.26645 0.008,0.0237 0.0445,0.0834 0.0533,0.10657 0.0187,0.0458 0.0301,0.11611 0.0533,0.15987 0.0243,0.0433 0.0779,0.11849 0.10658,0.15986 0.0446,0.0614 0.1055,0.1556 0.15987,0.21315 0.42631,0.47746 1.27678,0.69275 2.50454,0.69275 1.34715,1e-5 2.6431,-0.25578 3.83675,-0.85261 1.17662,-0.57977 2.12513,-1.44518 2.82427,-2.45126 0.51159,-0.7162 0.92083,-1.8182 1.27892,-3.25057 z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"none","stroke-width":"8.52610779","stroke-linecap":"butt","stroke-linejoin":"miter","stroke-miterlimit":"4"},attrs:{"id":"path2","d":"m 417.07944,250.20635 c 0.69221,1.77962 1.38445,3.55633 2.1055,5.2941 1.11046,2.36077 2.39396,4.6206 3.93704,6.73045 8.33557,11.33086 22.29546,17.53495 40.01931,19.07947 0,0 19.06506,0 19.06506,0 6.02811,-0.47014 12.34467,-1.34696 18.89198,-2.62759 11.29193,-2.2079 23.26167,-5.5998 35.69288,-10.13244 9.41715,-3.43375 19.0939,-7.49624 28.91485,-12.21778 21.38688,-10.25215 43.48041,-23.47509 65.15575,-39.43235 7.13857,-5.25082 13.98872,-10.63863 20.56487,-16.1173 6.02813,-5.01576 11.8111,-10.10942 17.33446,-15.25927 15.41645,-14.85689 27.0545,-29.94597 33.64507,-43.1949 6.86452,-13.7969 8.23461,-25.59358 2.61028,-33.02493 -3.44673,-4.56146 -9.21527,-7.00589 -16.64228,-7.5813 33.45753,-25.10471 52.95528,-55.55833 45.96096,-74.7589 -2.22096,-6.1277 -7.10981,-10.6992 -14.11858,-13.2273 -3.11497,-1.1205 -6.61943,-1.8301 -10.4411,-2.1531 0,0 -10.29683,0 -10.29683,0 -14.37808,1.0369 -35.28664,6.1853 -53.0249,14.8785"}}),_vm._v(" "),_c('g',{staticStyle:{"fill":"#00FFFF","fill-opacity":"1"},attrs:{"id":"g2","transform":"scale(1.705222,1.705222)"}},[_c('path',{attrs:{"id":"path1","transform":"translate(15.5783,177.825)","d":"m 0,36 c 0,0 7.46,0 7.46,0 0,0 3.35,-14 3.35,-14 0,0 12.12,0 12.12,0 0,0 1.56,-6 1.56,-6 0,0 -12.17,0 -12.17,0 0,0 2.02,-9 2.02,-9 0,0 12.95,0 12.95,0 0,0 1.56,-7 1.56,-7 C 28.85,0 8.4,0 8.4,0 8.4,0 0,36 0,36 z"}}),_vm._v(" "),_c('path',{attrs:{"id":"path2","transform":"translate(41.5283,187.825)","d":"m 7.51,26 c 0,0 2.24,-9.4 2.24,-9.4 1.18,-5.09 3.67,-9.6 8.38,-9.6 0.42,0 0.83,0.21 1.14,0.26 0,0 1.82,-7.21 1.82,-7.21 -0.42,0 -0.88,-0.05 -1.4,-0.05 -3.47,0 -6.38,2.44 -8.32,5.94 0,0 -0.2,0 -0.2,0 C 11.46,4.23 11.71,2.61 11.9,1 11.9,1 5.47,1 5.47,1 5.1,3.08 4.53,7.15 3.66,10.82 3.66,10.82 0,26 0,26 c 0,0 7.51,0 7.51,0 z"}}),_vm._v(" "),_c('path',{attrs:{"id":"path3","transform":"translate(62.1583,187.825)","d":"M 20.06,19.25 C 17.99,20.26 15.63,20 12.88,20 10.71,20 9.03,19.62 8.11,18.88 7.63,18.07 7.43,16.81 7.47,16 17.6,16.27 23.99,13.93 24.31,7.53 24.55,2.7 21.02,0 15.89,0 6.73,0 0.73,8.08 0.34,15.86 0,22.65 3.52,26 10.78,26 c 2.79,0 6.49,-0.32 9.52,-1.23 0,0 -0.24,-5.52 -0.24,-5.52 z M 17.32,7.53 C 17.2,9.91 14.26,10.05 8.47,10 9.1,7.91 11.22,6 14.69,6 c 1.71,0 2.69,0.65 2.63,1.53 z"}}),_vm._v(" "),_c('path',{attrs:{"id":"path4","transform":"translate(88.6783,187.825)","d":"M 20.05,19.25 C 17.98,20.26 15.62,20 12.88,20 10.7,20 9.03,19.62 8.11,18.88 7.63,18.07 7.42,16.81 7.46,16 17.6,16.27 23.98,13.93 24.31,7.53 24.55,2.7 21.02,0 15.89,0 6.72,0 0.72,8.08 0.33,15.86 0,22.65 3.52,26 10.77,26 c 2.8,0 6.5,-0.32 9.53,-1.23 0,0 -0.25,-5.52 -0.25,-5.52 z M 17.32,7.53 C 17.2,9.91 14.26,10.05 8.46,10 9.1,7.91 11.21,6 14.68,6 c 1.71,0 2.7,0.65 2.64,1.53 z"}}),_vm._v(" "),_c('path',{attrs:{"id":"path5","transform":"translate(124.5883,187.825)","d":"M 22.74,26 C 22.8,22.83 23.56,17.85 24.35,14.58 24.35,14.58 27.56,1 27.56,1 25.52,0.31 22.34,0 19.28,0 6.86,0 0.7,9.2 0.27,17.82 0,23.23 2.93,26 7.49,26 c 2.95,0 6.28,-1.43 8.87,-5.73 0,0 0.11,0 0.11,0 -0.2,2.07 -0.44,4.08 -0.57,5.73 0,0 6.84,0 6.84,0 z M 17.61,11.72 C 16.15,18.08 13.17,20 10.95,20 8.88,20 7.98,18.53 8.1,16.39 8.34,11.56 12.16,6 16.98,6 c 0.78,0 1.39,-0.14 1.96,-0.28 0,0 -1.33,6 -1.33,6 z"}}),_vm._v(" "),_c('path',{attrs:{"id":"path6","transform":"translate(152.2183,187.825)","d":"m 0,24.82 c 1.44,1.12 4.46,1.13 7.61,1.18 6.73,0.05 11.81,-2.89 12.11,-8.29 0.17,-3.6 -2.62,-5.73 -5.35,-7.16 C 12.4,9.6 11.41,8.69 11.46,7.63 11.53,6.2 12.87,6 14.84,6 c 2.22,0 4,0.27 5.02,0.47 0,0 2.02,-5.42 2.02,-5.42 C 20.73,0.36 18.43,0 15.48,0 8.95,0 4.17,3.45 3.9,8.69 c -0.16,3.24 2.17,5.42 4.99,6.9 2.28,1.17 3.06,2.07 3,3.34 C 11.82,20.21 10.68,20 8.61,20 6.18,20 3.49,19.68 2.07,19.46 2.07,19.46 0,24.82 0,24.82 z"}}),_vm._v(" "),_c('path',{attrs:{"id":"path7","transform":"translate(184.6683,176.825)","d":"m 7.45,37 c 0,0 6.05,-25 6.05,-25 0,0 -7.41,0 -7.41,0 0,0 -6.09,25 -6.09,25 0,0 7.45,0 7.45,0 z M 10.92,9 C 13.46,9 15.72,6.9 15.86,3.3 15.98,0.86 14.4,0 12.07,0 9.64,0 7.42,1.58 7.29,3.94 7.17,6.32 8.75,9 10.92,9 z"}}),_vm._v(" "),_c('path',{attrs:{"id":"path8","transform":"translate(198.9583,188.515)","d":"m 7.46,25.31 c 0,0 2.64,-11.26 2.64,-11.26 1.37,-5.73 4.32,-7.74 6.75,-7.74 1.92,0 2.48,0.82 2.39,2.01 -0.05,0.96 -0.2,1.97 -0.4,2.87 0,0 -3.36,14.12 -3.36,14.12 0,0 7.46,0 7.46,0 0,0 3.54,-14.81 3.54,-14.81 C 26.75,9.22 27.05,7.31 27.11,6.15 27.33,1.64 25.08,0 20.94,0 c -3.32,0 -6.55,1.54 -9.1,4.88 0,0 -0.1,0 -0.1,0 0,0 0.68,-4.57 0.68,-4.57 0,0 -6.58,0 -6.58,0 C 5.41,2.45 4.86,5.04 4.08,8.06 4.08,8.06 0,25.31 0,25.31 c 0,0 7.46,0 7.46,0 z"}}),_vm._v(" "),_c('path',{attrs:{"id":"path9","transform":"translate(238.5183,177.825)","d":"m 0,36 c 0,0 7.46,0 7.46,0 0,0 3.36,-14 3.36,-14 0,0 12.11,0 12.11,0 0,0 1.56,-6 1.56,-6 0,0 -12.17,0 -12.17,0 0,0 2.02,-9 2.02,-9 0,0 12.95,0 12.95,0 0,0 1.56,-7 1.56,-7 C 28.85,0 8.4,0 8.4,0 8.4,0 0,36 0,36 z"}}),_vm._v(" "),_c('path',{attrs:{"id":"path10","transform":"translate(264.4683,187.825)","d":"m 7.51,26 c 0,0 2.24,-9.4 2.24,-9.4 1.18,-5.09 3.67,-9.6 8.38,-9.6 0.42,0 0.83,0.21 1.14,0.26 0,0 1.82,-7.21 1.82,-7.21 -0.42,0 -0.88,-0.05 -1.4,-0.05 -3.47,0 -6.38,2.44 -8.32,5.94 0,0 -0.2,0 -0.2,0 C 11.46,4.23 11.71,2.61 11.9,1 11.9,1 5.47,1 5.47,1 5.11,3.08 4.53,7.15 3.66,10.82 3.66,10.82 0,26 0,26 c 0,0 7.51,0 7.51,0 z"}}),_vm._v(" "),_c('path',{attrs:{"id":"path11","transform":"translate(285.0983,187.825)","d":"M 20.06,19.25 C 17.99,20.26 15.63,20 12.88,20 10.71,20 9.03,19.62 8.11,18.88 7.63,18.07 7.43,16.81 7.47,16 17.6,16.27 23.99,13.93 24.31,7.53 24.55,2.7 21.02,0 15.89,0 6.73,0 0.73,8.08 0.34,15.86 0,22.65 3.53,26 10.78,26 c 2.79,0 6.5,-0.32 9.52,-1.23 0,0 -0.24,-5.52 -0.24,-5.52 z M 17.32,7.53 C 17.2,9.91 14.26,10.05 8.47,10 9.1,7.91 11.22,6 14.69,6 c 1.71,0 2.69,0.65 2.63,1.53 z"}}),_vm._v(" "),_c('path',{attrs:{"id":"path12","transform":"translate(311.6183,187.825)","d":"M 20.05,19.25 C 17.98,20.26 15.62,20 12.88,20 10.7,20 9.03,19.62 8.11,18.88 7.63,18.07 7.42,16.81 7.46,16 17.6,16.27 23.98,13.93 24.31,7.53 24.55,2.7 21.02,0 15.89,0 6.72,0 0.72,8.08 0.33,15.86 0,22.65 3.52,26 10.77,26 c 2.8,0 6.5,-0.32 9.53,-1.23 0,0 -0.25,-5.52 -0.25,-5.52 z M 17.32,7.53 C 17.2,9.91 14.26,10.05 8.46,10 9.1,7.91 11.21,6 14.68,6 c 1.71,0 2.7,0.65 2.64,1.53 z"}}),_vm._v(" "),_c('path',{attrs:{"id":"path13","transform":"translate(337.9983,176.825)","d":"M 23.31,0 C 23.31,0 20.5,11.36 20.5,11.36 19.48,10.94 18.15,11 17.11,11 7.53,11 0.75,19.2 0.3,28.08 0,34.34 3.34,37 7.64,37 c 3.01,0 6.18,-1.33 8.58,-4.77 0,0 0.1,0 0.1,0 0,0 -0.57,4.77 -0.57,4.77 0,0 6.78,0 6.78,0 0.31,-3 0.96,-6.57 1.69,-9.83 0,0 6.49,-27.17 6.49,-27.17 0,0 -7.4,0 -7.4,0 z M 17.47,24.42 C 16.3,29.35 13.54,31 11.36,31 9.19,31 7.98,29.49 8.13,26.8 8.38,21.82 11.8,17 16.25,17 c 1.25,0 2.32,0.19 2.91,0.47 0,0 -1.69,6.95 -1.69,6.95 z"}}),_vm._v(" "),_c('path',{attrs:{"id":"path14","transform":"translate(367.7083,187.825)","d":"M 10.61,26 C 19.31,26 26.02,19.41 26.49,10.44 26.78,4.5 23.08,0 16.25,0 7.23,0 0.76,7.3 0.31,16.12 0,22.54 4.14,26 10.61,26 z m 1.17,-6 C 9.24,20 7.84,18.38 7.99,15.96 8.19,11.93 10.68,6 14.97,6 c 2.96,0 3.87,2.27 3.75,4.5 -0.22,4.4 -2.9,9.5 -6.94,9.5 z"}}),_vm._v(" "),_c('path',{attrs:{"id":"path15","transform":"translate(396.2683,187.825)","d":"M 7.2,26 C 7.2,26 9.9,14.58 9.9,14.58 11.03,9.49 13.85,6 16.38,6 c 1.82,0 2.32,1.33 2.23,3.07 -0.05,0.9 -0.25,1.91 -0.46,2.91 0,0 -3.34,14.02 -3.34,14.02 0,0 7.2,0 7.2,0 0,0 2.7,-11.47 2.7,-11.47 C 25.95,9.28 28.61,6 31.09,6 c 1.71,0 2.42,1.22 2.34,2.96 -0.05,1.01 -0.26,2.12 -0.52,3.13 0,0 -3.24,13.91 -3.24,13.91 0,0 7.25,0 7.25,0 0,0 3.49,-14.81 3.49,-14.81 0.27,-1.33 0.58,-3.4 0.63,-4.46 C 41.26,2.33 39.11,0 35.23,0 31.91,0 28.68,1.5 26.23,4.66 26.14,2.38 24.51,0 20.47,0 17.2,0 14.08,1.48 11.58,4.83 c 0,0 -0.1,0 -0.1,0 0,0 0.67,-3.83 0.67,-3.83 0,0 -6.42,0 -6.42,0 C 5.31,3.14 4.8,5.73 4.02,8.75 4.02,8.75 0,26 0,26 c 0,0 7.2,0 7.2,0 z"}})])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p')])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"href":"https://phaser.io/news/2015/09/commando-thug","target":"_blank"}},[_vm._v("CommandoThug")]),_vm._v(" is a canvas based action game I made during the years 2014/2015\n                    "),_c('br'),_c('br'),_vm._v("\n\n                    It's based on the 2D game framework called \"Phaser\" which can be found "),_c('a',{attrs:{"href":"https://phaser.io/","target":"_blank"}},[_vm._v("here")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v("\n                    \n                    This game is now licensed under "),_c('a',{attrs:{"href":"https://www.gnu.org/licenses/quick-guide-gplv3.en.html","target":"_blank"}},[_vm._v("GPL v3")]),_vm._v(" "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"id":"downloadBtn"}},[_c('a',{attrs:{"href":"https://github.com/JUL1/CommandoThug/archive/master.zip"}},[_c('i',{staticClass:"icon",attrs:{"id":"download"}},[_vm._v("")]),_vm._v(" Download")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/4Af":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"id":"navBar"}},[_c('span',{attrs:{"id":"navBarBrand","target":"Home"}},[_vm._v("CMDT")]),_vm._v(" "),_c('span',{attrs:{"id":"navToggler"}},[_vm._v("MENU")]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":"navMenu"}},[_c('span',{staticClass:"navMenuItem",attrs:{"target":"Download"}},[_vm._v("DONWLOAD")]),_vm._v(" "),_c('span',{staticClass:"navMenuItem",attrs:{"target":"Controls"}},[_vm._v("CONTROLS")]),_vm._v(" "),_c('span',{staticClass:"navMenuItem",attrs:{"target":"Screenshots"}},[_vm._v("SCREENSHOTS")]),_vm._v(" "),_c('span',{staticClass:"navMenuItem",attrs:{"target":"Contact"}},[_vm._v("CONTACT")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1TbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mainContainer"}},[_c('h1',[_vm._v("ARTWORKS")]),_vm._v(" "),_c('div',{attrs:{"id":"gallery"}},[_c('span',{staticClass:"imgContainer"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork1.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Cybersawman","label":"PHOTOSHOP"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork2.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Robotic Mercenary","label":"PHOTOSHOP"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork5.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Gatling Fat Man","label":"PHOTOSHOP"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork4.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Mutant Flies","label":"PHOTOSHOP"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork3.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Mutant Plant","label":"PHOTOSHOP"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer noScale"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork8.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Fancy Button","label":"PHOTOSHOP"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer noScale"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork7.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"MiArmored","label":"FLASH"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork10.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"DodeZone","label":"FLASH"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork9.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"DodeZone","label":"FLASH"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer noScale"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork11.gif"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"MiArmored","label":"FLASH"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer noScale"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork6.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"LightBall","label":"PHOTOSHOP"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer noScale"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork12.png"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Boxer","label":"PHOTOSHOP"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer noScale"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork13.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Cyclop","label":"PHOTOSHOP"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer noScale"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork14.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Troll House","label":"FLASH"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer noScale"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork15.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Carzy Frog","label":"FLASH"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer noScale"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork16.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Characters","label":"FLASH"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer noScale"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork18.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"The Corporation","label":"ILLUSTRATOR"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer noScale"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork17.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Amazon","label":"DRAWING"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer noScale"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork19.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Swordman","label":"DRAWING"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer noScale"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork20.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"3D Character","label":"DRAWING"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer noScale"},[_c('img',{attrs:{"src":"/static/img/artworks/artwork21.jpg"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Boxer","label":"PHOTOSHOP"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1xiO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('body',{attrs:{"ontouchstart":""}},[_c('background'),_vm._v(" "),_c('navbar'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('foot')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3/E+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_747716ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Controls_vue__ = __webpack_require__("l8/j");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_747716ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Controls_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7RdU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mainContainer"}},[_c('h1',[_vm._v("LINKS")]),_vm._v(" "),_c('div',{staticClass:"links"},[_c('br'),_vm._v(" "),_c('h2',[_vm._v("UTILS")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.google.cm","target":"_blank"}},[_vm._v("Google")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.duckduckgo.com","target":"_blank"}},[_vm._v("DuckDuckGo")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://ixquick.fr/do/mypage.pl?prf=1357cf6d88289acdfcc994b6d589702a","target":"_blank"}},[_vm._v("Ixquick")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://gibiru.com/","target":"_blank"}},[_vm._v("Gibiru")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.bing.com/","target":"_blank"}},[_vm._v("Bing")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.tineye.com/","target":"_blank"}},[_vm._v("Tineye")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://postimg.org/","target":"_blank"}},[_vm._v("Postimg")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://imgjar.co/","target":"_blank"}},[_vm._v("Imgjar")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://github.com/","target":"_blank"}},[_vm._v("GitHub")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.youtube.com/watch?v=Jjhe6ypF6zc","target":"_blank"}},[_vm._v("Youtube")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.bitchute.com/","target":"_blank"}},[_vm._v("Bitchute")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://translate.google.com","target":"_blank"}},[_vm._v("Google Translate")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.colorzilla.com/gradient-editor/","target":"_blank"}},[_vm._v("CSS Gradients")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://kiwiirc.com/client","target":"_blank"}},[_vm._v("KIWIIRC")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://10minutemail.com/10MinuteMail/index.html","target":"_blank"}},[_vm._v("10MinuteMail")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.gmx.com/","target":"_blank"}},[_vm._v("GMX")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://protonmail.com/","target":"_blank"}},[_vm._v("Protonmail")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.javascriptobfuscator.com/","target":"_blank"}},[_vm._v("JS Obfuscator")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://caniuse.com/","target":"_blank"}},[_vm._v("CanIUse")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://anonym.to/","target":"_blank"}},[_vm._v("Anonym")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.shodanhq.com/","target":"_blank"}},[_vm._v("Shodanhq")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.norse-corp.com/","target":"_blank"}},[_vm._v("NorseCorp")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.mailinator.com/","target":"_blank"}},[_vm._v("Mailinator")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://game-icons.net/","target":"_blank"}},[_vm._v("Game icons")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://webtorrent.io/","target":"_blank"}},[_vm._v("Webtorrent")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.onstrat.com/osint/","target":"_blank"}},[_vm._v("Onstrat")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://bitly.com/","target":"_blank"}},[_vm._v("Bitly")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.minds.com/","target":"_blank"}},[_vm._v("Minds")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://gab.ai/","target":"_blank"}},[_vm._v("Gab")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"links"},[_c('br'),_vm._v(" "),_c('h2',[_vm._v("NEWS")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.zerohedge.com","target":"_blank"}},[_vm._v("Zerohedge")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.drudgereport.com","target":"_blank"}},[_vm._v("Drudge Report")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.corbettreport.com","target":"_blank"}},[_vm._v("Corbett Report")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.globalresearch.ca/","target":"_blank"}},[_vm._v("Global Research")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.telegraph.co.uk/finance/comment/ambroseevans_pritchard/","target":"_blank"}},[_vm._v("The Telegraph")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://thehackernews.com/","target":"_blank"}},[_vm._v("TheHackerNews")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.infowars.com/","target":"_blank"}},[_vm._v("InfoWars")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.fark.com/","target":"_blank"}},[_vm._v("Fark")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.thesmokinggun.com/","target":"_blank"}},[_vm._v("TheSmokingGun")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.abovetopsecret.com/","target":"_blank"}},[_vm._v("ATS")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://fr.news.yahoo.com/","target":"_blank"}},[_vm._v("YahooNews_FR")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://news.yahoo.com/us/","target":"_blank"}},[_vm._v("YahooNews_US")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://weeklyworldnews.com/","target":"_blank"}},[_vm._v("WeeklyWorldNews")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"links"},[_c('br'),_vm._v(" "),_c('h2',[_vm._v("RADIO")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://somafm.com/","target":"_blank"}},[_vm._v("Soma FM")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.jazzradio.fr/radio/webradio/electro-swing","target":"_blank"}},[_vm._v("Jazz Radio")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://swissclassic.radio.fr/","target":"_blank"}},[_vm._v("Swiss Classic")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.infowars.com/free-audio/","target":"_blank"}},[_vm._v("InfoWars")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.radioclassic.fi/","target":"_blank"}},[_vm._v("Radioclassic")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.shoutcast.com/radio/Classical","target":"_blank"}},[_vm._v("Shoutcast")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.fipradio.fr/player","target":"_blank"}},[_vm._v("Fip")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://radiolibertaire.radio.fr/","target":"_blank"}},[_vm._v("Radio Libertaire")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.radiocourtoisie.fr/presentation-de-radio-courtoisie/","target":"_blank"}},[_vm._v("Radio Courtoisie")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.franceculture.fr/player","target":"_blank"}},[_vm._v("France Culture")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.rfi.fr/contenu/ecouter-rfi-direct-monde","target":"_blank"}},[_vm._v("RFI")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"links"},[_c('br'),_vm._v(" "),_c('h2',[_vm._v("FORUM")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.html5gamedevs.com/","target":"_blank"}},[_vm._v("html5gamedevs")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"links"},[_c('br'),_vm._v(" "),_c('h2',[_vm._v("GAMES")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"links"},[_c('br'),_vm._v(" "),_c('h2',[_vm._v("MISC")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.mysqltutorial.org/","target":"_blank"}},[_vm._v("mysqltutorial")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.w3schools.com/sql/default.asp","target":"_blank"}},[_vm._v("w3schools")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.phptherightway.com/","target":"_blank"}},[_vm._v("phptherightway")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.ibm.com/developerworks/","target":"_blank"}},[_vm._v("IBM")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://symfony.com/doc/2.5/index.html","target":"_blank"}},[_vm._v("symfony")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.learn-angular.org/","target":"_blank"}},[_vm._v("learn-angular")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.angular2.com/","target":"_blank"}},[_vm._v("angular2")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br'),_vm._v(" "),_c('a',[_vm._v("---")]),_c('br')]),_vm._v(" "),_c('br'),_c('br'),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ALd/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mainContainer"}},[_c('h1',[_vm._v("CONTACT")]),_vm._v(" "),_c('p',[_vm._v("\n            \n                    Don't forget to check out my "),_c('a',{attrs:{"href":"#/Artworks"}},[_vm._v("artworks")]),_c('br'),_vm._v("\n                    You can also visit those "),_c('a',{attrs:{"href":"#/Links"}},[_vm._v("sites")]),_c('br'),_c('br'),_c('br'),_vm._v("\n\n                    Feel free to contact me by mail for job proposal"),_c('br'),_vm._v(" \n                    Or donate bitcoins at the address below :"),_c('br'),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"noSelect"},[_c('span',{staticClass:"inlineBlock"},[_c('i',{staticClass:"icon",attrs:{"id":"bitcoinIcon"}},[_vm._v("")]),_vm._v(" "),_c('p',{staticClass:"select",attrs:{"id":"donate"}},[_c('br'),_vm._v("DONATE BITCOIN:"),_c('br'),_c('br'),_vm._v("13cVc2FLV1bdWbdkk1S4qTgVnS6vhDeCNS")])]),_vm._v(" "),_c('span',{staticClass:"inlineBlock"},[_c('i',{staticClass:"icon",attrs:{"id":"mailIcon"}},[_vm._v("")]),_vm._v(" "),_c('p'),_c('div',{staticClass:"select",attrs:{"id":"contactMail"}},[_vm._v("CONTACT:"),_c('br'),_c('br'),_c('span',{attrs:{"id":"at","data-user":"jul.perso","data-domain":"mail.com"}})]),_c('p')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C0ZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mainContainer"}},[_c('h1',[_vm._v("SCREENSHOTS")]),_vm._v(" "),_c('div',{attrs:{"id":"gallery"}},[_c('span',{staticClass:"imgContainer"},[_c('img',{attrs:{"src":"/static/img/screenshots/1.png"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Screenshot 1","label":"COMMANDOTHUG"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer"},[_c('img',{attrs:{"src":"/static/img/screenshots/2.png"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Screenshot 2","label":"COMMANDOTHUG"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer"},[_c('img',{attrs:{"src":"/static/img/screenshots/3.png"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Screenshot 3","label":"COMMANDOTHUG"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer"},[_c('img',{attrs:{"src":"/static/img/screenshots/4.png"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Screenshot 4","label":"COMMANDOTHUG"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer"},[_c('img',{attrs:{"src":"/static/img/screenshots/5.png"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Screenshot 5","label":"COMMANDOTHUG"}})]),_vm._v(" "),_c('span',{staticClass:"imgContainer"},[_c('img',{attrs:{"src":"/static/img/screenshots/6.png"}}),_vm._v(" "),_c('span',{staticClass:"imgOverlay",attrs:{"title":"Screenshot 6","label":"COMMANDOTHUG"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D1hv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"BKG"}}),_vm._v(" "),_c('div',{attrs:{"id":"scanlines"}}),_vm._v(" "),_c('div',{attrs:{"id":"backFrame"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Drc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.navToggler = document.getElementById("navToggler");
    this.navMenu = document.getElementById("navMenu");
    this.navBarBrand = document.getElementById("navBarBrand");
    this.resizeHandler();
    this.setNavBarLinks();
  },


  methods: {
    toggleMenu: function toggleMenu(e, forceClose, url) {

      if (this.navToggler) {
        var visibility = window.getComputedStyle(this.navToggler, null).getPropertyValue("visibility");
        var style = window.getComputedStyle(this.navMenu, null).getPropertyValue("max-Height");
      }

      if (url) {
        this.goTo = url;
      } else {
        this.goTo = '';
      }

      if (visibility === "visible") {

        if (forceClose && style !== "0px") {

          this.navMenu.style.animationName = 'collapse';
        } else if (style !== "0px") {

          this.navMenu.style.animationName = 'collapse';
        } else if (!forceClose) {
          this.goTo = '';this.navMenu.style.animationName = 'expand';
        } else if (forceClose) {
          this.GOTO();
        }
      } else {
        this.GOTO();
      }
    },
    addNavButtonAnimation: function addNavButtonAnimation(e) {
      this.stopPropagation(e);e.target.style.animationName = 'flicker';
    },
    toggle: function toggle(e) {
      this.stopPropagation(e);e.target.style.animationName = 'flicker';this.toggleMenu(e);
    },
    GOTO: function GOTO() {

      if (this.goTo !== '') {

        this.$router.push({ name: this.goTo });
        this.goTo = '';
      }
      //                 window.open(this.goTo,"_self"); this.goTo='';}; 
    },
    resizeHandler: function resizeHandler() {

      if (this.navToggler) {
        var visibility = window.getComputedStyle(this.navToggler, null).getPropertyValue("visibility");
        var style = window.getComputedStyle(this.navMenu, null).getPropertyValue("max-height");

        if (visibility !== "visible" && style === "0px") {
          this.navMenu.style.maxHeight = "512px";
        } else if (visibility === "visible") {
          this.navMenu.style.maxHeight = "0px";
        };
      }
    },
    setNavBarLinks: function setNavBarLinks() {

      var parent = this;

      if (this.navToggler) {

        var elems = navMenu.getElementsByTagName("span");

        for (var i = 0; i < elems.length; i++) {

          if (this.isMobile) {
            elems[i].addEventListener("touchstart", this.addNavButtonAnimation, false);
          } else {
            elems[i].addEventListener("mousedown", this.addNavButtonAnimation, false);
          }

          elems[i].addEventListener('animationend', function (e) {

            e.target.style.animationName = '';
            parent.toggleMenu(e, false, e.target.getAttribute("target"));
          }, false);
        }

        if (this.isMobile) {
          this.navToggler.addEventListener("touchstart", this.toggle, false);
        } else {
          this.navToggler.addEventListener("mousedown", this.toggle, false);
        }

        this.navToggler.addEventListener('animationend', function (e) {
          e.target.style.animationName = '';
        }, false);

        this.navMenu.addEventListener('animationend', function (e) {

          if (e.target.style.animationName === "collapse") {
            e.target.style.maxHeight = "0px";parent.GOTO();
          } else if (e.target.style.animationName === "expand") {
            e.target.style.maxHeight = "100px";
          }

          e.target.style.animationName = '';
        }, false);
      }

      if (this.isMobile) {
        this.navBarBrand.addEventListener("touchstart", this.addNavButtonAnimation, false);
      } else {
        this.navBarBrand.addEventListener("mousedown", this.addNavButtonAnimation, false);
      }

      this.navBarBrand.addEventListener('animationend', function (e) {
        e.target.style.animationName = '';
        parent.toggleMenu(e, true, e.target.getAttribute("target"));
      }, false);

      window.addEventListener("resize", this.resizeHandler);
    }
    //end of methods

  } });

/***/ }),

/***/ "FnhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00f545f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("ALd/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00f545f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    mounted: function mounted() {
        this.clock = document.getElementById('clock');
        this.clock.textContent = new Date();
        this.clockInterval = setInterval(function () {
            this.clock.textContent = Date();
        }, 1000);
        this.btn = document.getElementById('playBtnIcn');
        this.addBtnListeners(this.btn);
    },
    beforeDestroy: function beforeDestroy() {
        window.clearInterval(this.clockInterval);
        this.removeBtnListeners(this.btn);
    },


    methods: {
        onBtnDown: function onBtnDown(e) {
            window.location.href = 'games/CommandoThug-master/index.html';
        },
        addBtnListeners: function addBtnListeners(btn) {

            btn.addEventListener("click", this.onBtnDown, false);
        },
        removeBtnListeners: function removeBtnListeners(btn) {

            btn.removeEventListener("click", this.onBtnDown);
        } //end of method

    } });

/***/ }),

/***/ "IOU3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16435fc1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Download_vue__ = __webpack_require__("+7x5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16435fc1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Download_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2f3637e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("1xiO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2f3637e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



//import "./assets/css/main.css"
//import "./assets/css/icons.css"

//Vue.config.productionTip = false
//Vue.config.productionTip = process.env.NODE_ENV == 'development'
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = "production" == 'production';
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "RlR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Screenshots_vue__ = __webpack_require__("V4Gk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aa418b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Screenshots_vue__ = __webpack_require__("C0ZT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Screenshots_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aa418b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Screenshots_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SAI9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00868527_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Background_vue__ = __webpack_require__("D1hv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00868527_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Background_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TNJk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4884c0d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Links_vue__ = __webpack_require__("7RdU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4884c0d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Links_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TVmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("UthT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90af80d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("W6Gm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90af80d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UthT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {

    this.setBtn(document.getElementById("options"));
  },


  methods: {

    animation: function animation(e) {
      this.stopPropagation(e);
      e.target.style.animationName = 'flicker';

      this.switchTheme();
    },
    switchTheme: function switchTheme() {

      switch (this.colorTheme) {
        case "red":
          document.getElementById("colorTheme").setAttribute("href", "/static/css/Terminal_Blue.css");
          this.colorTheme = "blue";localStorage.colorTheme = this.colorTheme;break;

        case "green":
          document.getElementById("colorTheme").setAttribute("href", "/static/css/Terminal_Red.css");
          this.colorTheme = "red";localStorage.colorTheme = this.colorTheme;break;

        case "blue":
          document.getElementById("colorTheme").setAttribute("href", "/static/css/Terminal_Green.css");
          this.colorTheme = "green";localStorage.colorTheme = this.colorTheme;break;
      }
    },
    setBtn: function setBtn(btn) {

      var parent = this;

      if (this.isMobile) {
        btn.addEventListener("touchstart", this.animation, false);
      } else {
        btn.addEventListener("mousedown", this.animation, false);
      }

      btn.addEventListener('animationend', function (e) {
        e.target.style.animationName = '';
        //parent.$router.push({ name:e.target.getAttribute("target") });
      }, false);
    }
    //end of methods

  } });

/***/ }),

/***/ "V4Gk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.initGallery();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeGallery();
  }
});

/***/ }),

/***/ "W6Gm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('span',{attrs:{"id":"options","target":"Options"}},[_vm._v("OPT")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Controls__ = __webpack_require__("3/E+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Screenshots__ = __webpack_require__("RlR0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Download__ = __webpack_require__("IOU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Contact__ = __webpack_require__("FnhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Artworks__ = __webpack_require__("tTyB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Links__ = __webpack_require__("TNJk");











//import Showcase from '@/components/Showcase'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
	mounted: function mounted() {
		this.isMobile = this.touchCapabilities();
		this.goTo = '';

		if (localStorage.colorTheme) {
			this.colorTheme = localStorage.colorTheme;
			this.setTheme();
		} else {
			this.colorTheme = "blue";
			localStorage.colorTheme = this.colorTheme;
		}
	},

	methods: {
		setTheme: function setTheme() {
			switch (this.colorTheme) {
				case "red":
					document.getElementById("colorTheme").setAttribute("href", "/static/css/Terminal_Red.css");break;
				case "green":
					document.getElementById("colorTheme").setAttribute("href", "/static/css/Terminal_Green.css");break;
				case "blue":
					document.getElementById("colorTheme").setAttribute("href", "/static/css/Terminal_Blue.css");break;
			}
		},
		touchCapabilities: function touchCapabilities() {
			return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
		},
		stopPropagation: function stopPropagation(e) {
			if (!e) e = window.event;if (e.stopPropagation) {
				e.stopPropagation();
			} else {
				e.cancelBubble = true;
			};
		},
		initGallery: function initGallery() {

			this.gallery = document.getElementById("gallery");
			this.viewer = undefined;
			this.viewerImg = undefined;
			this.imgCounter = 0;
			this.imgTitle = undefined;
			this.imgLabel = undefined;
			this.galleryLength = undefined;
			this.currentTarget = undefined;
			this.galleryElements = undefined;
			this.galleryIndex = 0;
			this.prevBtn = undefined;
			this.nextBtn = undefined;
			this.closeBtn = undefined;
			this.setUpGallery();
		},
		switchImg: function switchImg(e) {

			if (e.target.style.animationName === 'fadeOutImg') {
				e.target.style.animationName = 'fadeInImg';
				e.target.src = this.currentTarget.src;
			} else if (e.target.style.animationName === 'fadeInImg') {
				e.target.style.animationName = '';
			}
		},
		galleryIndexHandler: function galleryIndexHandler() {
			if (this.galleryIndex < 0) {
				this.galleryIndex = this.galleryLength - 1;
			} else if (this.galleryIndex >= this.galleryLength) {
				this.galleryIndex = 0;
			}
			this.currentTarget = this.galleryElements[this.galleryIndex];
			this.updateInfos();
		},
		updateInfos: function updateInfos() {
			var infos = this.currentTarget.nextElementSibling;
			this.imgTitle.textContent = infos.getAttribute("title");
			this.imgLabel.textContent = infos.getAttribute("label");
			this.imgCounter.textContent = parseInt(this.currentTarget.getAttribute("index")) + 1 + '/' + this.galleryLength;
		},
		closeViewer: function closeViewer() {
			this.viewer.style.animationName = 'fadeOut';
		},
		nextImg: function nextImg(e) {
			this.galleryIndex += 1;
			this.galleryIndexHandler();
			this.updateInfos();
			if (this.nextBtn.style.animationName === "fadeBtn") {
				this.nextBtn.style.animation = "";
				this.nextBtn.offsetHeight;
			};
			this.viewerImg.style.animationName = 'fadeOutImg';
			this.nextBtn.style.animationName = 'fadeBtn';
		},
		prevImg: function prevImg(e) {
			this.galleryIndex -= 1;
			this.galleryIndexHandler();
			this.updateInfos();
			if (this.prevBtn.style.animationName === "fadeBtn") {
				this.prevBtn.style.animation = "";
				this.prevBtn.offsetHeight;
			};
			this.viewerImg.style.animationName = 'fadeOutImg';
			this.prevBtn.style.animationName = 'fadeBtn';
		},
		openViewer: function openViewer(e) {

			this.currentTarget = e.target;
			this.viewerImg.src = e.target.src;
			this.galleryIndex = parseInt(e.target.getAttribute("index"));
			this.updateInfos();
			this.viewer.style.visibility = "visible";
			this.viewer.style.animationName = 'fadeIn';
		},
		endAnim: function endAnim(e) {

			e.target.style.animationName = '';
		},
		viewerAnimEnd: function viewerAnimEnd(e) {

			if (e.target.style.animationName === "fadeIn") {
				e.target.style.visibility = "visible";
				e.target.style.animationName = '';
			} else if (e.target.style.animationName === "fadeOut") {
				e.target.style.visibility = "hidden";
				e.target.style.animationName = '';
			}
		},
		setUpGallery: function setUpGallery() {

			var parent = document.body;

			var mc = document.getElementById("mainContainer");

			this.viewer = document.createElement("div");
			this.viewer.id = "viewer";

			this.viewerImg = document.createElement("img");
			this.viewerImg.id = "viewerImg";
			//viewerImg.src="./img/artworks/artwork1.jpg";
			this.viewer.appendChild(this.viewerImg);

			this.prevBtn = document.createElement("span");
			this.prevBtn.id = "prevBtn";
			this.viewer.appendChild(this.prevBtn);

			this.nextBtn = document.createElement("span");
			this.nextBtn.id = "nextBtn";
			this.viewer.appendChild(this.nextBtn);

			this.imgCounter = document.createElement("span");
			this.imgCounter.id = "imgCounter";
			this.viewer.appendChild(this.imgCounter);

			this.imgTitle = document.createElement("span");
			this.imgTitle.id = "imgTitle";
			this.viewer.appendChild(this.imgTitle);

			this.imgLabel = document.createElement("span");
			this.imgLabel.id = "imgLabel";
			this.viewer.appendChild(this.imgLabel);

			this.closeBtn = document.createElement("span");
			this.closeBtn.id = "closeBtn";
			this.viewer.appendChild(this.closeBtn);

			mc.parentNode.insertBefore(this.viewer, mc);
			//
			//console.log(turf);

			if (this.isMobile) {

				this.closeBtn.addEventListener("touchstart", this.closeViewer, false);
				this.nextBtn.addEventListener("touchstart", this.nextImg, false);
				this.prevBtn.addEventListener("touchstart", this.prevImg, false);
				this.viewerImg.addEventListener("touchstart", this.nextImg, false);
			} else {
				this.closeBtn.addEventListener("mousedown", this.closeViewer, false);
				this.nextBtn.addEventListener("mousedown", this.nextImg, false);
				this.prevBtn.addEventListener("mousedown", this.prevImg, false);
				this.viewerImg.addEventListener("mousedown", this.nextImg, false);
			}

			this.viewer.addEventListener('animationend', this.viewerAnimEnd, false);

			this.nextBtn.addEventListener('animationend', this.endAnim, false);
			this.prevBtn.addEventListener('animationend', this.endAnim, false);

			this.viewerImg.addEventListener('animationend', this.switchImg, false);

			this.galleryElements = this.gallery.getElementsByTagName("img");

			this.galleryLength = this.galleryElements.length;

			for (var i = 0; i < this.galleryLength; i++) {

				this.galleryElements[i].setAttribute("index", i);

				if (this.isMobile) {
					this.galleryElements[i].addEventListener("touchstart", this.openViewer, false);
				} else {
					this.galleryElements[i].addEventListener("mousedown", this.openViewer, false);
				}
			}
		},
		removeGallery: function removeGallery() {

			if (this.isMobile) {

				this.closeBtn.removeEventListener("touchstart", this.closeViewer, false);
				this.nextBtn.removeEventListener("touchstart", this.nextImg, false);
				this.prevBtn.removeEventListener("touchstart", this.prevImg, false);
				this.viewerImg.removeEventListener("touchstart", this.nextImg, false);
			} else {
				this.closeBtn.removeEventListener("mousedown", this.closeViewer, false);
				this.nextBtn.removeEventListener("mousedown", this.nextImg, false);
				this.prevBtn.removeEventListener("mousedown", this.prevImg, false);
				this.viewerImg.removeEventListener("mousedown", this.nextImg, false);
			}

			this.viewer.removeEventListener('animationend', this.viewerAnimEnd);

			this.nextBtn.removeEventListener('animationend', this.endAnim);
			this.prevBtn.removeEventListener('animationend', this.endAnim);
			this.viewerImg.removeEventListener('animationend', this.switchImg);

			for (var i = 0; i < this.galleryLength; i++) {

				if (this.isMobile) {
					this.galleryElements[i].removeEventListener("touchstart", this.openViewer);
				} else {
					this.galleryElements[i].removeEventListener("mousedown", this.openViewer);
				}
			}
			while (this.viewer.firstChild) {
				this.viewer.removeChild(this.viewer.firstChild);
			}

			this.viewer.parentElement.removeChild(this.viewer);
		}
	}

});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{ path: '/', name: 'Home', component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */] }, { path: '/Download', name: 'Download', component: __WEBPACK_IMPORTED_MODULE_5__components_Download__["a" /* default */] }, { path: '/Controls', name: 'Controls', component: __WEBPACK_IMPORTED_MODULE_3__components_Controls__["a" /* default */] }, { path: '/Screenshots', name: 'Screenshots', component: __WEBPACK_IMPORTED_MODULE_4__components_Screenshots__["a" /* default */] }, { path: '/Contact', name: 'Contact', component: __WEBPACK_IMPORTED_MODULE_6__components_Contact__["a" /* default */] },
	//{ path: '/Options', name: 'Options', component: Options },
	//{ path: '/Showcase', name: 'Showcase', component: Showcase },
	{ path: '/Artworks', name: 'Artworks', component: __WEBPACK_IMPORTED_MODULE_7__components_Artworks__["a" /* default */] }, { path: '/Links', name: 'Links', component: __WEBPACK_IMPORTED_MODULE_8__components_Links__["a" /* default */] }]
}));

/***/ }),

/***/ "h/pm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.initGallery();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeGallery();
  }
});

/***/ }),

/***/ "l8/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mainContainer"}},[_c('h1',[_vm._v("CONTROLS")]),_vm._v(" "),_c('div',{staticClass:"inlinePanel"},[_c('span',{staticClass:"noSelect"},[_c('i',{staticClass:"icon",attrs:{"id":"mobileIcon"}},[_vm._v("")]),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('h2',[_vm._v("MOBILE")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n                        Touch the screen to move your soldier"),_c('br'),_c('br'),_c('br'),_vm._v("\n                        Your soldier moves toward touch inputs"),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"inlinePanel"},[_c('span',{staticClass:"noSelect"},[_c('i',{staticClass:"icon",attrs:{"id":"pointerIcon"}},[_vm._v("")]),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('h2',[_vm._v("MOUSE")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n                        Use the mouse to move your soldier"),_c('br'),_c('br'),_c('br'),_vm._v("\n                        Your soldier will follow the pointer"),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"inlinePanel"},[_c('span',{staticClass:"noSelect"},[_c('i',{staticClass:"icon",attrs:{"id":"keyboardIcon"}},[_vm._v("")]),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('h2',[_vm._v("KEYBOARD")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n                        Use keyboard arrows to move your soldier"),_c('br'),_c('br'),_c('br'),_vm._v("\n                        UP, DOWN, LEFT, RIGHT"),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"inlinePanel"},[_c('span',{staticClass:"noSelect"},[_c('i',{staticClass:"icon",attrs:{"id":"pointerKeyboard"}},[_vm._v("")]),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('h2',[_vm._v("2 Players")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n                        Available in the game's options menu"),_c('br'),_c('br'),_c('br'),_vm._v("\n                        Player1 mouse"),_c('br'),_vm._v(" \n                        Player2 keyboard\n                        ")])]),_vm._v(" "),_c('p',[_c('br'),_c('br'),_vm._v(" - - -  Your soldier shoots automatically at the closest target  - - -  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32b50118_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("xJA7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32b50118_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lfLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("Drc2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565a6389_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("/4Af");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565a6389_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tTyB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Artworks_vue__ = __webpack_require__("h/pm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00bbaa90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Artworks_vue__ = __webpack_require__("1TbH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Artworks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00bbaa90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Artworks_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJA7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"mainContainer"}},[_c('div',{attrs:{"id":"playBtn","target":"Games"}},[_c('i',{staticClass:"icon",attrs:{"id":"playBtnIcn"}},[_vm._v("")]),_vm._v(" "),_c('div',{attrs:{"id":"clock"}},[_vm._v("--- : --- : ---")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Background_vue__ = __webpack_require__("SAI9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Navbar_vue__ = __webpack_require__("lfLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer_vue__ = __webpack_require__("TVmP");
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Background: __WEBPACK_IMPORTED_MODULE_0__components_Background_vue__["a" /* default */],
    Navbar: __WEBPACK_IMPORTED_MODULE_1__components_Navbar_vue__["a" /* default */],
    Foot: __WEBPACK_IMPORTED_MODULE_2__components_Footer_vue__["a" /* default */]
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5e5f3ce893bfd4e49c8e.js